'use strict';

let viewport = require('responsive-toolkit/dist/bootstrap-toolkit');

viewport.use('app', {
    'mobile':  $('<div class="device-xs visible-xs visible-xs-block"></div>'),
    'tablet':  $('<div class="device-sm visible-sm visible-sm-block"></div>'),
    'desktop': $('<div class="device-md visible-md visible-md-block device-lg visible-lg visible-lg-block"></div>')
});

viewport.get = function(): ?string {
    return ['mobile', 'tablet', 'desktop'].find((device) => viewport.is(device)) || null;
}

export default viewport;



// WEBPACK FOOTER //
// ./app/Resources/assets/js/lib/viewport.js